import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useAppContext } from '../AppContext';
import './Window.css'
import DoubleTap from './DoubleTap';
import "98.css"

const Window = ({ id }) => {
    const { state, dispatch } = useAppContext();
    const [dragging, setDragging] = useState(false);
    const [offset, setOffset] = useState({ x: 0, y: 0 });
    const windowRef = useRef(null);

    const updateDimensions = () => {
        if (windowRef.current) {
            dispatch({ 'type': 'SET_WIDTH_HEIGHT', payload: { id: id, width: windowRef.current.offsetWidth, height: windowRef.current.offsetHeight} });
        }
    };


    useEffect(() => {
        if (state.components[id].width !== 'number') {
            updateDimensions();
        }
    }, []);


    const handleMouseDown = (e) => {
        if (e.target.className === 'title-bar' || e.target.className === 'title-bar-text') {
            e.preventDefault();
            e.stopPropagation();

            setDragging(true);
            setOffset({
                x: !state.components[id].maximized ? e.clientX - state.components[id].x : state.components[id].width / 2,
                y: !state.components[id].maximized ? e.clientY - state.components[id].y : 6,
            });
        }
        dispatch({ type: 'SET_ACTIVE_COMPONENT', component: id });
    };

    const handleMouseMove = useCallback(
        (e) => {
            if (dragging && state.activeComponent === id) {
                e.preventDefault();
                e.stopPropagation();
                if (state.components[id].maximized) {
                    dispatch({ 'type': 'TOGGLE_MAXIMIZED', payload: { id: id} });
                }
                dispatch({
                    type: 'SET_POSITION',
                    component: id,
                    x: e.clientX - offset.x,
                    y: e.clientY - offset.y,
                });
            }
        }, [dragging, state.activeComponent, id, offset, dispatch, state.components]
    );

    const handleMouseUp = useCallback(() => {
        setDragging(false);
    }, []);

    const handleTouchStart = (e) => {
        console.error(e.target.ClassName)
        if (e.target.className === 'title-bar' || e.target.className === 'title-bar-text') {
            const touch = e.targetTouches[0];
            e.stopPropagation();

            setDragging(true);
            setOffset({
                x: !state.components[id].maximized ? touch.pageX - state.components[id].x: touch.pageX - state.components[id].width / 2,
                y: !state.components[id].maximized ? touch.pageY - state.components[id].y: 6,
            });
        }
        dispatch({ type: 'SET_ACTIVE_COMPONENT', component: id });
    }

    const handleTouchMove = useCallback(
        (e) => {
            if (dragging && state.activeComponent === id) {
                e.stopPropagation();
                if (state.components[id].maximized) {
                    dispatch({ 'type': 'TOGGLE_MAXIMIZED', payload: { id: id } });
                }
                const touch = e.targetTouches[0];
                dispatch({
                    type: 'SET_POSITION',
                    component: id,
                    x: touch.pageX - offset.x,
                    y: touch.pageY - offset.y,
                })

            }
        }, [dragging, state.activeComponent, id, offset, dispatch, state.components]
    )

    const handleTouchEnd = useCallback(() => {
        setDragging(false);
    }, []);


    const onClose = () => {
        dispatch({ type: 'CLOSE_APP', id: id });
    };

    const toggleMinimized = () => {
        dispatch({ type: 'TOGGLE_MINIMIZED', id: id, minimized: true })
    };

    const toggleMaximized = () => {
        if (!state.components[id].maximized) {
            updateDimensions();
        }
        dispatch({ type: 'TOGGLE_MAXIMIZED', payload: { id: id} });
    };

    const windowStyle = {
        left: state.components[id].maximized ? '6px' : state.components[id].x === 'number' ? `${state.components[id].x}px` : `${state.components[id].x}px`,
        top: state.components[id].maximized ? '6px' : state.components[id].y === 'number' ? `${state.components[id].y}px` : `${state.components[id].y}px`,
        width: state.components[id].maximized ? '100%' : `${state.components[id].width}px`,
        height: state.components[id].maximized ? '100%' : `${state.components[id].height}px`,
        position: 'absolute',
        zIndex: `${state.components[id].minimized ? 0 : state.components[id].z}`,
        minWidth: `${state.components[id].minWidth}`,
        minHeight: `${state.components[id].minHeight}`,
        resize: state.components[id].resizable ? 'both' : 'none'
    };

    return (
        <div className="window"
            style={windowStyle}
            onMouseMove={handleMouseMove}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            ref={windowRef}
        >
            <DoubleTap onDoubleTap={toggleMaximized}>
                <div className="title-bar">
                    <div className='title-bar-text'>
                        {state.components[id].name}
                    </div>
                    <div className="title-bar-controls">
                        <button aria-label="Minimize" onClick={toggleMinimized} />
                        <button aria-label="Maximize" onClick={toggleMaximized} />
                        <button aria-label="Close" onClick={onClose} />
                    </div>
                </div>
            </DoubleTap>
            <div className="program-body">
                {state.components[id].contents}
            </div>
        </div>
    );
};

export default Window;